import React from "react";
import VerificationPanel from "@/components/VerificationPanel";
import { BadgeCheck } from "lucide-react";

export default function VerifyPage() {
  return (
    <div data-testid="verify-page">
      <section className="vj-dark vj-radial-fade px-6 lg:px-12 py-20">
        <div className="max-w-[1400px]">
          <div className="overline text-slate-400 flex items-center gap-2"><BadgeCheck size={14}/> Credential Verification</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-[1.05] mt-4 max-w-4xl">
            Verify any VAJRON-issued credential.
          </h1>
          <p className="text-slate-300 mt-6 max-w-2xl leading-relaxed">
            Enter the Credential ID provided by VAJRON Global Tech Pvt. Ltd. to retrieve the holder's verified internship record.
          </p>
        </div>
      </section>

      <section className="px-6 lg:px-12 py-16 max-w-[1100px]">
        <VerificationPanel />
      </section>
    </div>
  );
}
